// noinspection JSUnusedLocalSymbols
//noinspection ES6UnusedImports

/**
 * Hive Template: Main JS
 * -------------------------------------------------------------
 * @copyright {{PKG_COPYRIGHT}}
 * @license   {{PKG_LICENSE}}
 * @version   {{PKG_VERSION}}, {{PKG_DATE}}
 */

import Navbar from "@phmg/apis/src/js/StickyNavbar.js";
import LayoutHelper from "@phmg/apis/src/js/helpers/LayoutHelper.js";
import ViewportHelper from "@phmg/apis/src/js/helpers/ViewportHelper.js";
import LoadHelper from "@phmg/apis/src/js/helpers/LoadHelper.js";
//import BodyLockHelper from "@phmg/apis/src/js/helpers/BodyLockHelper.js";
// Import Styles
import '../scss/template.scss';

console.log('{{PKG_NAME}}', '{{PKG_VERSION}}', '{{PKG_DATE}}');

let NAVIGATION = null;

let HiveInterface;
if (typeof window.Hive === 'undefined') {
  window.addEventListener('defined.hv.core', () => {
    HiveInterface = window.Hive;
  })
} else {
  HiveInterface = window.Hive;
}

// Init helpers
ViewportHelper.init();
LayoutHelper.init();
LoadHelper.init();

// ready event
document.addEventListener('DOMContentLoaded', () => {
  // add ready class
  document.body.classList.add('ready');
  // Remove no-script class
  document.body.classList.remove('no-script');

  // Another shot of the detective (great, AI!)
  HiveInterface.featureInterface.detected('touchScreen').then(isTouchScreen => {
    document.documentElement.classList.toggle('is-touch', isTouchScreen);
    document.documentElement.classList.toggle('no-touch', !isTouchScreen);
  });

  // Lazy load stylesheets
  document.head.querySelectorAll('link[rel="lazy-stylesheet"]')
    .forEach(linkElement => {
      linkElement.rel = 'stylesheet';
    });

  // Init navbar
  NAVIGATION = Navbar.getInstance('#navigation');

  /** Balance Text Plugin */
  const style = document.createElement('style');
  style.innerHTML = '.balance-text { text-wrap: balance; }';
  // find last style tag or link rel="stylesheet" and insert after
  const styleTag = document.head.querySelector('style,link[rel="stylesheet"]');
  if (styleTag) {
    styleTag.parentNode.insertBefore(style, styleTag.nextSibling);
  } else {
    document.head.appendChild(style);
  }

  // add class to
  // - page-title, item-title
  // - page-text-body > h3, h4, h5, h6
  // not to p, looks ugly when justified
  let selectors = 'h1,h2,.page-title,.item-title,.module-title,.section-title,';
  selectors += ['h3', 'h4', 'h5', 'h6'].map(tag => `div.page-text-body > ${tag}`).join(',');
  document.querySelectorAll(selectors).forEach(element => {
    // remove visually-hidden elements, add balance-text class
    const hiddenElement = element.querySelector('.visually-hidden');
    hiddenElement && hiddenElement.remove();
    element.classList.add('balance-text')
  });
});

// load event
window.addEventListener('load', () => {
  document.body.classList.add('loaded')

  // Run balance-text plugin
  if ('balanceText' in window) window.balanceText();

  // Add tooltips
  //const tooltipElements = document.querySelectorAll('[data-toggle="tooltip"],[data-bs-toggle="tooltip"]')
  //const tooltipList = [...tooltipElements].map(element => new Tooltip(element))
});

// Joomla dialog events
document.addEventListener('joomla-dialog:open', () => {
  HiveInterface.domInterface.blockScrolling.block()
})
document.addEventListener('joomla-dialog:close', () => {
  HiveInterface.domInterface.blockScrolling.unblock()
})

document.addEventListener('beforeunload', () => {
  document.body.classList.add('unload')
})
